<div class="tw-px-6 tw-py-8 tw-relative">
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-4 tw-right-4 tw-p-[5px] tw-rounded-full" (click)="close()">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-[13px] tw-h-[13px] tw-text-400 tw-leading-4 tw-text-black tw-font-bold">&#10005;</div>
  </div>
  <ng-content></ng-content>
</div>
